import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link, useParams } from 'react-router-dom';
import Slider from "react-slick";
import "../home/Home.css";
import "../offers/Offers.css";
import "../experience/Experience.css"
//Navbar and Left Section Images
// import hayatin from '../../assets/images/hayatin.jpg';
// import homeicon from '../../assets/home-images/homeicon.jpg';
// import experienceicon from '../../assets/home-images/experienceicon.jpg';
// import eventsicon from '../../assets/home-images/eventsicon.jpg';
import businessicon from '../../assets/home-images/businessicon.jpg';
// import plusicon from '../../assets/home-images/plusicon.png';

// import messageicon from '../../assets/home-images/messageicon.png';
// import bellicon from '../../assets/home-images/bellicon.png';

// import profileicon from '../../assets/home-images/profileicon.png';
// import search from '../../assets/home-images/search.png';
// import videos from '../../assets/home-images/videos.png';
// import blogs from '../../assets/home-images/blogs.png';
// import save from '../../assets/home-images/save.png';
// import menu from '../../assets/home-images/menu.png';
// import downarrow from '../../assets/home-images/downarrow.png';

//offers mid section
// import offer_bgimg1 from "../../assets/offers/offer_bgimg1.png";
// import heartplus from '../../assets/offers/heartplus.png';
// import upload from '../../assets/offers/upload.png';
import rightarrow from '../../assets/home-images/right-section-images/rightarrow.png';
import leftarrow from '../../assets/offers/leftarrow.png';
// carousel
// import carouselimg1 from '../../assets/offers/carouselimg1.png';
// import carouselimg2 from '../../assets/offers/carouselimg2.png';
// import exploreabudhabi from "../../assets/experience/exploreabudhabi.mp4";

import star from '../../assets/experience/star.png';
import menuicon from '../../assets/offers/menuicon.png';
// import rotana1 from '../../assets/home-images/mid-section-images/rotana1.png';

// import map from '../../assets/offers/map.png';
// import pin from '../../assets/offers/pin.png';
// import direction_arrow from '../../assets/offers/direction_arrow.png';

//carousel
// import heartplus1 from '../../assets/offers/heartplus1.png';
// import redheart from '../../assets/experience/redheart.png';
// import brunch1 from '../../assets/experience/brunch1.png';
// import brunch2 from '../../assets/experience/brunch2.png';
// import brunch3 from '../../assets/experience/brunch3.png';

import xmark from '../../assets/home-images/right-section-images/xmark.png';
import popup_yatch from "../../assets/offers/popup_yatch.png";

import hayatlogo from '../../assets/home-images/right-section-images/hayatlogo.png';
import qr from '../../assets/home-images/right-section-images/qr.png';
import app_store from '../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../assets/home-images/right-section-images/play_store.png';
import { BACKEND_URL, fastApiCall, fastApiClient } from "../common/Common";
import axios from "axios";
import campopup from '../../assets/home-images/cam-popup.png';
import vidpopup from '../../assets/home-images/vid-popup.png';
import offerpopup from '../../assets/home-images/offer-popup.png';
import eventpopup from '../../assets/home-images/event-popup.png';
import spotlightpopup from '../../assets/home-images/spotlight-popup.png';
import carouselpopup from '../../assets/home-images/carouselpopup.png';
import Navbar from "../common-component/navbar/Navbar";
import LeftSection from "../common-component/left-menu-section/LeftSection";



const Offers = () => {
    const { couponId, categoryId } = useParams();
    const sliderRef = useRef(null);
    const youMayLikeSliderRef = useRef(null);
    const [downloadPopupOpen, setDownloadPopupOpen] = useState(false);
    const [coupondetail, setCoupondetail] = useState([]);
    console.log("Coupon ID:", couponId);
    const [remindMe, setRemindMe] = useState(false);
    const [activeTab, setActiveTab] = useState("Details");
    // const [getbrandlist, setGetbrandlist] = useState([]);
    const [categorylist, setCategorylist] = useState([]);
    const hasAmenities = coupondetail[0]?.amenities?.length > 0;
    // const [selectedCategory, setSelectedCategory] = useState(null);
    // const [categoryName, setCategoryName] = useState("");
    const [vendordetails, setVendordetails] = useState([]);
    const [relatedcoupon, setRelatedcoupon] = useState([]);

    const [mediaItems, setMediaItems] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [postpopup, setPostpopup] = useState(false);
    const popupRef = useRef(null);
    const [expand, setExpand] = useState(false);
    const [loading, setLoading] = useState(true);

    const [isFollowing, setIsFollowing] = useState(false);
    // const user_id = coupondetail[0]?.user_id;


    const fetchCoupondetails = async (couponId) => {
        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-coupon-details`, {
                    latitude: 24.5,
                    longitude: 54.4,
                    coupon_id: couponId,
                }),
                null, // No separate loading state for this individual call
                (data) => {
                    const extractedData = data?.data || data || [];
                    setCoupondetail(extractedData);
                    // Hide main loading IMMEDIATELY when primary data is loaded
                    setLoading(false);
                },
                (responseData) => responseData?.data || responseData
            );
            return true;
        } catch (error) {
            console.error("Error fetching coupon details:", error);
            setCoupondetail([]);
            // Hide loading even on error so user sees something
            setLoading(false);
            return false;
        }
    }

    const fetchvendordetails = async (userId) => {
        if (!userId) {
            console.log("❌ No user_id provided");
            return false;
        }

        try {
            const loggedInUserId = localStorage.getItem('user_id') || sessionStorage.getItem('user_id');
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-vendor-details`, {
                    id: userId,
                    login_user_id: loggedInUserId || 501
                }),
                null,
                (data) => {
                    setVendordetails(data);
                    // SET FOLLOW STATUS FROM RESPONSE
                    setIsFollowing(data?.is_following || false);
                }
            );
            return true;
        } catch (error) {
            console.error("Error fetching vendor details:", error);
            return false;
        }
    }

    const state = vendordetails?.state || "";
    const city = vendordetails?.city || "";


    const fetchCategorylist = async (categoryId, couponId) => {
        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-coupon-list`, {
                    state_id: 1,
                    latitude: 24.5,
                    longitude: 54.4,
                    category_id: categoryId
                }),
                null, // No separate loading state for this individual call
                (data) => {
                    let extractedData = data?.data || data || [];
                    extractedData = extractedData.filter(item => item.coupon_id !== Number(couponId));
                    setCategorylist(extractedData);
                },
                (responseData) => responseData?.data || responseData
            );
            return true;
        } catch (error) {
            console.error("Error fetching category list:", error);
            setCategorylist([]);
            return false;
        }
    };

    const fetchRelatedcoupon = async (categoryId, couponId) => {
        try {
            const payload = {
                state_id: 1,
                latitude: 24.5,
                longitude: 54.4
            };

            // If categoryId exists → use categoryId
            if (categoryId && categoryId !== 0) {
                payload.category_id = categoryId;
                // console.log("Using category_id:", categoryId);

            } else {
                // If category_id is 0 → fallback to coupon_id
                payload.coupon_id = couponId;
            }

            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-coupon-list`, payload),
                null, // No separate loading state for this individual call
                (data) => {
                    let extractedData = data?.data || data || [];
                    // Remove current coupon from list
                    extractedData = extractedData.filter(item => item.coupon_id !== Number(couponId));
                    setRelatedcoupon(extractedData);
                },
                (responseData) => responseData?.data || responseData
            );
            return true;
        } catch (error) {
            console.error("Error fetching related coupons:", error);
            setRelatedcoupon([]);
            return false;
        }
    };


    // MORE LESS CONCEPT - IT WILL DISAPPEAR IF TEXT COMES UNDER 2 LINES
    const [showToggle, setShowToggle] = useState(false);
    const descRef = useRef(null);
    const mainDescRef = useRef(null); // Separate ref for main description

    useEffect(() => {
        // Check main description element after render
        const checkDescriptionHeight = () => {
            if (mainDescRef.current && coupondetail[0]?.description) {
                const el = mainDescRef.current;
                const lineHeight = parseFloat(getComputedStyle(el).lineHeight) || 24; // fallback to 24px if not set
                const maxHeight = lineHeight * 2; // 2 lines
                if (el.scrollHeight > maxHeight) {
                    setShowToggle(true);
                } else {
                    setShowToggle(false);
                }
            } else {
                setShowToggle(false);
            }
        };

        // Run immediately
        checkDescriptionHeight();

        // Also run after a small delay to ensure DOM is fully rendered
        const timer = setTimeout(checkDescriptionHeight, 100);

        return () => clearTimeout(timer);
    }, [coupondetail]);

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            try {
                // Load primary data first (coupon details) - this will hide loading when done
                if (couponId) {
                    await fetchCoupondetails(couponId);
                }

                // Load secondary data in parallel (don't wait for these)
                const secondaryPromises = [];

                if (couponId) {
                    secondaryPromises.push(fetchRelatedcoupon(categoryId, couponId));
                }
                if (categoryId && couponId) {
                    secondaryPromises.push(fetchCategorylist(categoryId, couponId));
                }
                // secondaryPromises.push(fetchGetbrandlist());

                // Don't await - let these load in background
                Promise.all(secondaryPromises).catch(error => {
                    console.error("Error loading secondary data:", error);
                });
            } catch (error) {
                console.error("Error loading data:", error);
                setLoading(false);
            }
            // Note: setLoading(false) is now handled inside fetchCoupondetails for faster display
        };

        loadData();
    }, [couponId, categoryId]);

    useEffect(() => {
        if (coupondetail[0]?.user_id) {
            fetchvendordetails(coupondetail[0].user_id);
        }
    }, [coupondetail]);

    const isUserLoggedIn = () => {
        const userId = localStorage.getItem('user_id') || sessionStorage.getItem('user_id');
        const userStr = localStorage.getItem('user');
        return !!(userId && userStr);
    };

    // Follow/Unfollow handler
    const handleFollowToggle = async (e) => {
        // Prevent any default behavior
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (!isUserLoggedIn()) {
            setDownloadPopupOpen(true);
            return;
        }

        const loggedInUserId = localStorage.getItem('user_id') || sessionStorage.getItem('user_id');
        const vendorUserId = coupondetail[0]?.user_id;

        if (!vendorUserId) {
            console.error("❌ No vendor user_id found");
            return;
        }

        const payload = {
            login_user_id: loggedInUserId,
            user_id: vendorUserId,
            is_following: !isFollowing
        };

        // Optimistically update UI first
        setIsFollowing(!isFollowing);

        try {
            const response = await axios.post(
                `${BACKEND_URL}website/save-followers`,
                payload
            );

            // Verify the response indicates success
            if (!response.data || response.data.error) {
                console.error("❌ Backend failed to save follow status");
                // Revert the optimistic update
                setIsFollowing(isFollowing);
            } else {
                // Re-fetch vendor details to get updated follower count
                if (vendorUserId) {
                    fetchvendordetails(vendorUserId);
                }
            }
        } catch (error) {
            console.error("❌ Follow error:", error);
            // Revert the optimistic update on error
            setIsFollowing(isFollowing);
        }
    };

    // Scroll to top immediately when component mounts or route params change
    // Using useLayoutEffect to run synchronously before paint
    useLayoutEffect(() => {
        const scrollToTop = () => {
            // Scroll window
            window.scrollTo(0, 0);

            // Scroll document body (for older browsers)
            if (document.body) {
                document.body.scrollTop = 0;
            }

            // Scroll documentElement (for some browsers)
            if (document.documentElement) {
                document.documentElement.scrollTop = 0;
            }

            // Check for scrollable containers
            const middleSection = document.querySelector('.offers-middle-section');
            if (middleSection) {
                middleSection.scrollTop = 0;
            }
        };

        // Scroll immediately before paint
        scrollToTop();
    }, [couponId, categoryId]);

    // Also scroll after render completes (backup)
    useEffect(() => {
        if (couponId) {
            const scrollToTop = () => {
                window.scrollTo(0, 0);
                if (document.body) document.body.scrollTop = 0;
                if (document.documentElement) document.documentElement.scrollTop = 0;

                const middleSection = document.querySelector('.offers-middle-section');
                if (middleSection) middleSection.scrollTop = 0;
            };

            // Scroll immediately
            scrollToTop();

            // Scroll again after short delay to handle any async rendering
            const timeout = setTimeout(scrollToTop, 100);

            // Scroll again after loading completes
            if (!loading) {
                setTimeout(scrollToTop, 300);
            }

            return () => clearTimeout(timeout);
        }
    }, [couponId, categoryId, loading]);

    useEffect(() => {
        // console.log("coupondetail:", coupondetail);
    }, [coupondetail]);

    useEffect(() => {
        if (coupondetail[0]) {
            setRemindMe(coupondetail[0].remind_me);
        }
    }, [coupondetail]);



    useEffect(() => {
        if (coupondetail.length > 0) {
            const imgs = coupondetail[0]?.coupon_images?.map(img => ({
                type: "img",
                src: img.image
            })) || [];

            setMediaItems(imgs);

            if (imgs.length > 0) {
                setSelectedImage(imgs[0].src);
            }
        }
    }, [coupondetail]);

    // Reset "you may like" carousel to start from first card
    useEffect(() => {
        if (youMayLikeSliderRef.current && categorylist.length > 0) {
            const timer = setTimeout(() => {
                if (youMayLikeSliderRef.current) {
                    youMayLikeSliderRef.current.slickGoTo(0);
                }
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [categorylist]);


    const settings = {
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 4000,
        pauseOnHover: true,
        centerMode: false,
        arrows: false,
        dots: false,
        swipe: true,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1,
                    swipe: true,
                    swipeToSlide: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.5,
                    slidesToScroll: 1,
                    swipe: true,
                    swipeToSlide: true,
                    arrows: false,
                }
            }
        ]
    };

    const getSlidesToShow = () => {
        const width = window.innerWidth;
        if (width >= 993) return 3;      // Desktop
        if (width >= 769 && width <= 992) return 1.5;  // Tablet - show 1.5 cards
        if (width >= 320 && width < 769) return 1.5; // Mobile - show 1.5 cards
        return 1; // fallback
    };

    const [slidesToShow, setSlidesToShow] = useState(getSlidesToShow());

    useEffect(() => {
        const handleResize = () => setSlidesToShow(getSlidesToShow());
        window.addEventListener("resize", handleResize);

        // Immediately set correct value in case dev tools changed width before render
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const offerSettings = {
        infinite: slidesToShow >= 3, // Only infinite for desktop (3+ cards)
        slidesToShow,
        slidesToScroll: 1,
        arrows: true,
        autoplay: false,
        dots: false,
        centerMode: false,
        initialSlide: 0,
        swipe: true,
        swipeToSlide: true,
        touchMove: true,
        speed: 300,
        cssEase: "ease-out",
    };

    // Shimmer Component
    const ShimmerOffers = () => (
        <div className="offers-main-layout">
            <LeftSection />
            <main className="offers-middle-section">
                {/* Breadcrumb shimmer - hidden on mobile */}
                <div className="offer-ptags shimmer-line shimmer-breadcrumb"></div>

                {/* Section 1 shimmer */}
                <div className="offer-section1">
                    <div className="offer-left">
                        <div className="offer_bgimg1 shimmer-box shimmer-hero-image"></div>
                    </div>
                    <div className="offer-right">
                        <div className="offer-section1-header shimmer-header">
                            <div className="shimmer-circle shimmer-icon"></div>
                            <div className="shimmer-line shimmer-text-medium"></div>
                        </div>
                        <div className="shimmer-line shimmer-title"></div>
                        <div className="carousel-container shimmer-carousel">
                            <div className="shimmer-box shimmer-carousel-item"></div>
                        </div>
                        <div className="offer-section1-bottom shimmer-rating">
                            <div className="shimmer-line shimmer-rating-text"></div>
                        </div>
                    </div>
                </div>

                {/* Description shimmer */}
                <div className="description shimmer-description">
                    <div className="shimmer-line shimmer-text-full"></div>
                    <div className="shimmer-line shimmer-text-partial"></div>
                </div>

                {/* Applicable for shimmer */}
                <div className="offer-applicabale shimmer-applicable">
                    <div className="shimmer-box shimmer-badge-large"></div>
                    <div className="shimmer-box shimmer-badge-small"></div>
                </div>

                {/* Price offer cards shimmer */}
                <div className="price-offer-cards shimmer-price-cards">
                    <div className="price-offer-card-container shimmer-card">
                        <div className="shimmer-line shimmer-price-text"></div>
                        <div className="icon-iconheading shimmer-icon-heading">
                            <div className="shimmer-circle shimmer-vendor-icon"></div>
                            <div className="shimmer-line shimmer-vendor-name"></div>
                        </div>
                        <div className="price-offer-btn shimmer-buttons">
                            <div className="shimmer-box shimmer-btn-large"></div>
                            <div className="shimmer-box shimmer-btn-medium"></div>
                            <div className="shimmer-box shimmer-btn-small"></div>
                        </div>
                    </div>
                </div>

                {/* Remind me shimmer */}
                <div className="remind-me-container shimmer-remind">
                    <div className="shimmer-circle shimmer-checkbox"></div>
                    <div className="shimmer-line shimmer-remind-text"></div>
                </div>

                {/* Tabs shimmer */}
                <div className="offer-tabs shimmer-tabs">
                    <div className="shimmer-line shimmer-tab"></div>
                    <div className="shimmer-line shimmer-tab"></div>
                    <div className="shimmer-line shimmer-tab"></div>
                </div>

                {/* Tab content shimmer */}
                <div className="description1 shimmer-tab-content">
                    <div className="shimmer-line shimmer-text-full"></div>
                    <div className="shimmer-line shimmer-text-partial-95"></div>
                    <div className="shimmer-line shimmer-text-partial-90"></div>
                </div>

                {/* Offered by shimmer */}
                <h6 className="offered-by shimmer-section-title">
                    <div className="shimmer-line shimmer-title-small"></div>
                </h6>
                <div className="offered-by-container shimmer-offered-by">
                    <div className="offered-by-img-content-container shimmer-offered-by-content">
                        <div className="shimmer-circle shimmer-vendor-image"></div>
                        <div className="offered-by-content shimmer-vendor-info">
                            <div className="shimmer-line shimmer-text-medium"></div>
                            <div className="shimmer-line shimmer-text-small"></div>
                            <div className="shimmer-line shimmer-text-small"></div>
                        </div>
                    </div>
                </div>

                {/* You may like shimmer */}
                <h6 className="you-may-like shimmer-section-title">
                    <div className="shimmer-line shimmer-title-medium"></div>
                </h6>
                <div className="you-may-like-section shimmer-carousel-section">
                    <div className="shimmer-carousel-items">
                        {[1, 2, 3].map((item) => (
                            <div key={item} className="offer-card shimmer-carousel-card">
                                <div className="offer-img-wrapper shimmer-box shimmer-card-image"></div>
                                <div className="offer-details shimmer-card-details">
                                    <div className="shimmer-line shimmer-text-small"></div>
                                    <div className="shimmer-line shimmer-text-medium"></div>
                                    <div className="shimmer-line shimmer-text-small"></div>
                                    <div className="shimmer-line shimmer-text-small"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
        </div>
    );

    if (loading) {
        return (
            <div>
                <Navbar />
                <ShimmerOffers />
            </div>
        );
    }

    if (!coupondetail[0]) return null;

    return (
        <div>
            <Navbar />

            <div className="offers-main-layout">
                <LeftSection />
                <main className="offers-middle-section">

                    <div className="offer-ptags">
                        {coupondetail[0]?.category?.filter(cat => cat.category === categoryId).length > 0 ? (
                            coupondetail[0].category
                                .filter(cat => cat.category === categoryId)
                                .map((item, index) => (
                                    <p key={index}>
                                        Experience / Special Offer / <span>{item.category_name}</span>
                                    </p>
                                ))
                        ) : (
                            <p>Experience / Special Offer</p>
                        )}
                    </div>



                    <div className="offer-section1">
                        <div className="offer-left">
                            {selectedImage && (
                                <div
                                    className="offer_bgimg1"
                                    style={{ backgroundImage: `url(${selectedImage})` }}
                                />
                            )}
                        </div>


                        {/* RIGHT SIDE */}
                        <div className="offer-right offer-detail">
                            {/* Header row */}
                            <div className="offer-section1-header">
                                <div className="offer-section1-icon-ptag">
                                    <img src={businessicon} alt="businessicon" className="businessicon" />
                                    <p>{coupondetail[0]?.user_name}</p>


                                </div>
                                <div className="offer-section1-heart-upload">
                                    {/* <img src={heartplus} alt="heart" />
                                    <img src={upload} alt="upload" /> */}
                                </div>
                            </div>

                            {/* H3 content below */}
                            <h3>{coupondetail[0]?.coupon_title}</h3>
                            <div className="carousel-container">
                                {
                                    mediaItems.length === 1 ? (
                                        // Single image
                                        <img
                                            src={mediaItems[0].src}
                                            alt="single-media"
                                            className="single-image"
                                        />
                                    ) : (
                                        // Carousel for 2 or more images
                                        <>
                                            {mediaItems.length > 3 && (
                                                <img
                                                    src={leftarrow}
                                                    alt="left"
                                                    className="arrows"
                                                    onClick={() => sliderRef.current.slickPrev()}
                                                />
                                            )}

                                            <div className="slider-wrapper">
                                                <Slider ref={sliderRef} {...settings}>
                                                    {mediaItems.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            className="carousel-item"
                                                            onClick={() => setSelectedImage(item.src)}
                                                        >
                                                            <img src={item.src} alt={`media-${index}`} />
                                                        </div>
                                                    ))}
                                                </Slider>
                                            </div>

                                            {mediaItems.length > 3 && (
                                                <img
                                                    src={rightarrow}
                                                    alt="right"
                                                    className="arrows"
                                                    onClick={() => sliderRef.current.slickNext()}
                                                />
                                            )}
                                        </>
                                    )
                                }

                            </div>



                            {/* <div className="offer-section1-bottom">
                                <p className="rating-integer">5.0</p>
                                <img src={star} alt="star" className="star" />
                                <img src={star} alt="star" className="star" />
                                <img src={star} alt="star" className="star" />
                                <img src={star} alt="star" className="star" />
                                <img src={star} alt="star" className="star" />
                                <p className="review-rating">(1 reviews)</p>
                            </div> */}
                        </div>
                    </div>
                    <div className="description">
                        {coupondetail[0]?.description && (() => {
                            // const descLimit = 60; // characters to decide if truncation needed
                            const descTruncateLength = 200; // characters to show before "More"

                            // Show "More" only if text length exceeds the truncate length
                            const shouldTruncate = coupondetail[0].description.length > descTruncateLength;

                            return (
                                <p className={`coupon-description-text ${expand ? "expanded" : ""}`}>
                                    {expand
                                        ? coupondetail[0].description
                                        : shouldTruncate
                                            ? `${coupondetail[0].description.substring(0, descTruncateLength)}... `
                                            : coupondetail[0].description
                                    }

                                    {shouldTruncate && (
                                        <span
                                            className="coupon-description-toggle"
                                            onClick={() => setExpand(!expand)}
                                        >
                                            {expand ? "Less" : "More"}
                                        </span>
                                    )}
                                </p>
                            );
                        })()}
                    </div>



                    <div className="offer-applicabale">
                        {coupondetail[0]?.applicable_for === 0 ? (
                            <div className="applicable-for">
                                <p>Applicable for : In-Store Purchases</p>
                            </div>
                        ) : coupondetail[0]?.applicable_for === 1 ? (
                            <div className="applicable-for">
                                <p>Applicable for : Online Purchases</p>
                            </div>
                        ) : <div className="applicable-for">
                            <p>Applicable for :  In-Store and Online Purchases</p>
                        </div>
                        }

                        {coupondetail[0]?.menu === "" ? (
                            null
                        ) : (
                            <div className="menu-container" onClick={() => setDownloadPopupOpen(true)}>
                                <img src={menuicon} alt="menu" />
                                <p>Menu</p>
                            </div>
                        )}
                    </div>

                    <div className="price-offer-cards" >
                        {coupondetail[0]?.discount_types.map((item, index) => {
                            let discountText;
                            if (item.discount_type === "From") {
                                discountText = (
                                    <span className="discount_type_from">
                                        From <span className="discount_coupon_price">AED {item.coupon_price}</span>
                                    </span>
                                );
                            } else if (item.discount_type === "Total") {
                                discountText = (
                                    <span className="offer-tag">{item.discount_value}% OFF</span>
                                );
                            } else if (item.discount_value && item.discount_price && item.coupon_price) {
                                discountText = (
                                    <>
                                        <span className="old-price">AED {item.coupon_price}</span>
                                        <span className="new-price">AED {item.discount_price}</span>
                                        <span className="separator">|</span>
                                        <span className="discount">{item.discount_value}% OFF</span>
                                    </>
                                );
                            } else {
                                discountText = (
                                    <span className="offer-tag">AED {item.coupon_price}</span>
                                );
                            }

                            return (
                                <div className="price-offer-card-container" onClick={() => setDownloadPopupOpen(true)}>
                                    <div className="offer-prices page-discount-text">{discountText}</div>
                                    <div className="icon-iconheading">

                                        <div className="icon-with-border">
                                            <img src={coupondetail[0]?.user_image} alt="Vendor" />
                                        </div>
                                        <h4>{item.coupon_title}</h4>
                                    </div>
                                    <div className="price-offer-btn">
                                        <div className="valid-btn">
                                            <p>
                                                Valid until{" "}
                                                {coupondetail[0]?.end_date
                                                    ? new Date(coupondetail[0].end_date).toLocaleDateString("en-GB", {
                                                        day: "2-digit",
                                                        month: "short",
                                                        year: "numeric",
                                                    })
                                                    : ""}
                                            </p>
                                        </div>
                                        <div className="unlimited-btn">
                                            {coupondetail[0]?.coupon_usage_type === 1 ? (
                                                <p>Unlimited</p>
                                            ) : (
                                                <p>Limited</p>
                                            )}

                                        </div>
                                        <div className="usenow-btn">
                                            <p>Use Now</p>
                                        </div>
                                    </div>
                                </div>
                            )

                        })}
                    </div>


                    <div className="remind-me-container">
                        <input
                            type="checkbox"
                            id="remind-me"
                            checked={remindMe}
                            // onChange={() => setRemindMe(!remindMe)}
                            onClick={() => setDownloadPopupOpen(true)}
                        />
                        <label type="remind-me">Remind me later</label>
                    </div>

                    <div>
                        {/* Tabs */}
                        <div className="offer-tabs">
                            <button
                                className={activeTab === "Details" ? "active" : ""}
                                onClick={() => setActiveTab("Details")}
                            >
                                Details
                            </button>
                            <button
                                className={activeTab === "Guide" ? "active" : ""}
                                onClick={() => setActiveTab("Guide")}
                            >
                                Guide
                            </button>
                            <button
                                className={activeTab === "T&Cs" ? "active" : ""}
                                onClick={() => setActiveTab("T&Cs")}
                            >
                                T&Cs
                            </button>
                            {/* {hasAmenities && (
                                <button
                                    className={activeTab === "Amenities" ? "active" : ""}
                                    onClick={() => setActiveTab("Amenities")}
                                >
                                    Amenities
                                </button>
                            )} */}
                        </div>

                        <div className="description1">
                            {activeTab === "Details" && (
                                <div className="coupon-details">
                                    <p
                                        ref={descRef}
                                        className={`coupon-description-text ${expand ? "expanded" : ""}`}
                                    >
                                        {coupondetail[0]?.details}
                                    </p>

                                    {showToggle && (
                                        <span
                                            className="coupon-description-toggle"
                                            onClick={() => setExpand(!expand)}
                                        >
                                            {expand ? "Less" : "More"}
                                        </span>
                                    )}
                                </div>
                            )}

                            {activeTab === "Guide" && (
                                <div className="coupon-details">
                                    <p
                                        ref={descRef}
                                        className={`coupon-description-text ${expand ? "expanded" : ""}`}
                                    >
                                        {coupondetail[0]?.guide}
                                    </p>

                                    {showToggle && (
                                        <span
                                            className="coupon-description-toggle"
                                            onClick={() => setExpand(!expand)}
                                        >
                                            {expand ? "Less" : "More"}
                                        </span>
                                    )}
                                </div>
                            )}
                            {activeTab === "T&Cs" && (
                                <div className="coupon-details">
                                    <p
                                        ref={descRef}
                                        className={`coupon-description-text ${expand ? "expanded" : ""}`}
                                    >
                                        {coupondetail[0]?.terms_and_conditions}
                                    </p>

                                    {showToggle && (
                                        <span
                                            className="coupon-description-toggle"
                                            onClick={() => setExpand(!expand)}
                                        >
                                            {expand ? "Less" : "More"}
                                        </span>
                                    )}
                                </div>
                            )}


                            {/* {activeTab === "T&Cs" && <p>{coupondetail[0].terms_and_conditions}</p>} */}
                            {activeTab === "Amenities" && hasAmenities && (
                                <ul>
                                    {coupondetail[0].amenities.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>

                    {/* <div className="map-bg" style={{ backgroundImage: `url(${map})` }}>
                        <div className="pin-location">
                            <img src={pin} alt="pin" className="pin1" />
                            <img src={pin} alt="pin" className="pin2" />
                        </div>

                        <div className="location-detail-container">
                            <div className="location-direction-arrow">
                                <p>Marina City, Abu Dhabi</p>
                                <img src={direction_arrow} alt="direction_arrow" />
                            </div>
                            <div>
                                <button className="view-branches-btn">
                                    View More Branches
                                </button>
                            </div>
                        </div>
                    </div> */}

                    <h6 className="offered-by">Offered by</h6>
                    <div className="offered-by-container">
                        <div className="offered-by-img-content-container">
                            <Link
                                to={`/vendordetails/${coupondetail[0]?.user_id}`}
                                className="remove-underline"
                            >
                                <img src={coupondetail[0]?.user_image} alt="Vendor" className="offered-by-rotana1" />

                            </Link>
                            <div className="offered-by-content">
                                <div className="offered-by-heading">
                                    <Link
                                        to={`/vendordetails/${coupondetail[0]?.user_id}`}
                                        className="remove-underline"
                                    >
                                        <h6>{coupondetail[0]?.user_name}</h6>
                                    </Link>
                                    <button
                                        className="follow-btn"
                                        onClick={handleFollowToggle}
                                        style={{
                                            backgroundColor: isFollowing ? "#DBE8FF" : "#1877f2",
                                            color: isFollowing ? "#031955" : "#fff"
                                        }}
                                    >
                                        {isFollowing ? "Following" : "Follow"}
                                    </button>
                                </div>
                                <div className="offer-section1-bottom">
                                    <div className="rating-container">
                                        <span className="rating">5.0</span>
                                        <div className="stars">
                                            <img src={star} alt="star" className="star" />
                                            <img src={star} alt="star" className="star" />
                                            <img src={star} alt="star" className="star" />
                                            <img src={star} alt="star" className="star" />
                                            <img src={star} alt="star" className="star" />
                                        </div>
                                        <span className="reviews">(1 reviews)</span>
                                    </div>
                                </div>
                                <p className="location">{city}, {state}</p>
                            </div>
                        </div>
                    </div>

                    {categorylist?.length > 0 && (
                        <>
                            <h6 className="you-may-like">You may also like</h6>

                            <div className="you-may-like-section">
                                <Slider ref={youMayLikeSliderRef} {...offerSettings}>
                                    {categorylist.map((item, index) => {
                                        let discountText;

                                        switch (item.discount_type_id) {
                                            case 8:
                                            case 4:
                                                discountText = (
                                                    <span className="offer-tag">{item.discount_type}</span>
                                                );
                                                break;

                                            case 7:
                                                discountText = (
                                                    <span className="offer-tag">
                                                        {item.discount_value
                                                            ? `${item.discount_value}% OFF`
                                                            : item.discount_type}
                                                    </span>
                                                );
                                                break;

                                            case 5:
                                                discountText = (
                                                    <span className="offer-tag">
                                                        Up to {item.discount_value ? `${item.discount_value}% OFF` : ""}
                                                    </span>
                                                );
                                                break;

                                            case 1:
                                                discountText =
                                                    item.discount_value &&
                                                        item.discount_price &&
                                                        item.coupon_price ? (
                                                        <>
                                                            <span className="old-price">AED {item.coupon_price}</span>
                                                            <span className="new-price">AED {item.discount_price}</span>
                                                            <span className="separator">|</span>
                                                            <span className="discount">{item.discount_value}% OFF</span>
                                                        </>
                                                    ) : (
                                                        <span className="offer-tag">AED {item.coupon_price}</span>
                                                    );
                                                break;

                                            case 10:
                                                discountText = (
                                                    <span className="discount_type_from">
                                                        From{" "}
                                                        <span className="discount_coupon_price">
                                                            AED {item.coupon_price}
                                                        </span>
                                                    </span>
                                                );
                                                break;

                                            default:
                                                discountText =
                                                    item.discount_type === "Total" ? (
                                                        <span className="offer-tag">
                                                            {item.discount_value}% OFF
                                                        </span>
                                                    ) : (
                                                        <span className="offer-tag">
                                                            {item.discount_type}
                                                        </span>
                                                    );
                                        }

                                        return (
                                            <a
                                                key={index}
                                                href={`/offers/${item.coupon_id}/${item.category[0]?.category}`}
                                                className="remove-underline"
                                            >
                                                <div className="offer-card">
                                                    <div className="offer-img-wrapper">
                                                        <img
                                                            src={item.coupon_image}
                                                            alt="festive season"
                                                        />
                                                    </div>

                                                    <div className="offer-details">
                                                        <p className="offer-location">
                                                            <span>
                                                                <img
                                                                    src={businessicon}
                                                                    alt="logo"
                                                                    className="bussinessicon"
                                                                />
                                                            </span>
                                                            <span>{item.user_name}</span>
                                                        </p>

                                                        <h4>{item.coupon_title}</h4>

                                                        <p className="limited-deals-distance">
                                                            {Math.round(item.distance)} km |{" "}
                                                            {item.location}
                                                        </p>

                                                        <div className="offer-prices">
                                                            {discountText}
                                                        </div>
                                                    </div>
                                                </div>
                                            </a>
                                        );
                                    })}
                                </Slider>
                            </div>
                        </>
                    )}


                </main>


                {downloadPopupOpen && (
                    <>
                        <div className="overlay" onClick={() => setDownloadPopupOpen(false)}></div>
                        <div className="download-popup-drawer">
                            <div className="pop-up-img">
                                <img src={popup_yatch} alt="pop up yatch" className="pop-up-yatch" />
                            </div>
                            <div className="popup-header">
                                <div className="pop-up-download">
                                    <div className="hayaticon">
                                        <img src={hayatlogo} alt="Hayat In Logo" />
                                        <div className="close-btn">
                                            <img src={xmark} alt="xmark" className="close-popup" onClick={() => setDownloadPopupOpen(false)} />
                                        </div>
                                    </div>
                                    <h4 className="download-hayat">Download Our App </h4>
                                    <p id="App-description">
                                        Scan the QR code with your phone and open Hayat In instantly
                                        Your gateway to discovering the city in one tap.
                                    </p>

                                    <div className="store-buttons">
                                        <div className="app_qr">
                                            <a
                                                href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img src={app_store} alt="App Store" />
                                            </a>

                                            <a
                                                href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img src={play_store} alt="Google Play" />
                                            </a>
                                        </div>


                                        <div className="app_qr">
                                            <img className="qr" src={qr} alt="QR code" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </>
                )}

                {postpopup && (
                    <div className="popup-overlay" onClick={() => setPostpopup(false)}>
                        <div className="popup-box" ref={popupRef} onClick={(e) => e.stopPropagation()}>

                            <div className="popup-options">
                                <Link to="/HomeCarouselOffer" className="remove-underline">
                                    <div className="popup-item">
                                        <img src={campopup} alt="Post" />
                                        <p>Post</p>
                                    </div>
                                </Link>

                                <div className="popup-item">
                                    <img src={vidpopup} alt="Video" />
                                    <p>Video</p>
                                </div>

                                <div className="popup-item">
                                    <img src={carouselpopup} alt="Carousel" />
                                    <p>Carousel</p>
                                </div>

                                <div className="popup-item">
                                    <img src={offerpopup} alt="Offer" />
                                    <p>Offer</p>
                                </div>

                                <div className="popup-item">
                                    <img src={spotlightpopup} alt="Spotlight" />
                                    <p>Spotlight</p>
                                </div>

                                <div className="popup-item">
                                    <img src={eventpopup} alt="Event" />
                                    <p>Event</p>
                                </div>

                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};


export default Offers;